var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElSalvador(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 39.9999C31.0457 39.9999 40 31.0456 40 19.9999C40 8.95418 31.0457 -0.00012207 20 -0.00012207C8.9543 -0.00012207 0 8.95418 0 19.9999C0 31.0456 8.9543 39.9999 20 39.9999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 -0.00012207C12.0707 -0.00012207 5.2195 4.61433 1.9845 11.3043H38.0154C34.7804 4.61433 27.9291 -0.00012207 20 -0.00012207V-0.00012207Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 39.9998C27.9291 39.9998 34.7804 35.3854 38.0154 28.6954H1.9845C5.2195 35.3854 12.0707 39.9998 20 39.9998Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9836 20.8694L20 13.913L24.0165 20.8694H15.9836Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2174 23.1664L20 25.7752L14.7826 23.1664V19.6882H25.2174V23.1664Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.919 14.2114L23.0744 16.056C23.8612 16.8428 24.3479 17.9298 24.3479 19.1304C24.3479 21.5317 22.4012 23.4782 20.0001 23.4782C17.5989 23.4782 15.6523 21.5316 15.6523 19.1304C15.6523 17.9298 16.139 16.8428 16.9258 16.056L15.0812 14.2114C13.8222 15.4702 13.0436 17.2093 13.0436 19.1304C13.0436 22.9724 16.1581 26.0869 20.0001 26.0869C23.842 26.0869 26.9566 22.9724 26.9566 19.1304C26.9565 17.2093 26.1779 15.4702 24.919 14.2114V14.2114Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElSalvador);
export default __webpack_public_path__ + "static/media/el_salvador.973ae3a5279a0b324cebdd04b6029860.svg";
export { ForwardRef as ReactComponent };